export default __webpack_public_path__ + "static/media/stayHome.6bb9fb3f.jpeg";